/**
 * @generated SignedSource<<9d08472fd6f32dde9ae0770424dab467>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MeetingRecordingBannerCreditUpdater_user$data = {
  readonly id: string;
  readonly " $fragmentType": "MeetingRecordingBannerCreditUpdater_user";
};
export type MeetingRecordingBannerCreditUpdater_user$key = {
  readonly " $data"?: MeetingRecordingBannerCreditUpdater_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingRecordingBannerCreditUpdater_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeetingRecordingBannerCreditUpdater_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "a34b24033a734187e40f3b642717d571";

export default node;
